// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"8804293e","186":"c3ecf0c9","344":"54ac1691","359":"866c038e","372":"067ec1ce","681":"3d8b377a","738":"e4eada28","815":"5a24da60","841":"45896d87","856":"20cc775d","965":"d59f7f20"}[chunkId] + ".chunk.js";
};